import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainWorkspaceComponent } from './components/main-workspace/main-workspace.component';
import { AppShellComponent } from './components/app-shell/app-shell.component';
import { TokenVirtualAdminComponent } from './components/token-virtual-admin/token-virtual-admin.component';
import { AdminHubComponent } from './components/admin-hub/admin-hub.component';
import { AdminDownloadPanelComponent } from './components/admin-download-panel/admin-download-panel.component';
import { AdminJoinKeysComponent } from './components/admin-join-keys/admin-join-keys.component';
import { GestionHubComponent } from './components/gestion-hub/gestion-hub.component';
import { GestionEstadoTramiteComponent } from './components/gestion-estado-tramite/gestion-estado-tramite.component';
import { GestionFacturaComponent } from './components/gestion-factura/gestion-factura.component';
import { GestionRevocarComponent } from './components/gestion-revocar/gestion-revocar.component';
import { TokenFisicoAdminComponent } from './components/token-fisico-admin/token-fisico-admin.component';
import { DescargarCertificadoComponent } from './components/descargar-certificado/descargar-certificado.component';
import { CcswAuthCallbackComponent } from './components/ccsw-auth-callback/ccsw-auth-callback.component';

const adminChildren = (opts: { supportsReset: boolean; supportsJoinKeys?: boolean }) => {
  const children: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'descargar' },
    { path: 'descargar', component: AdminDownloadPanelComponent }
  ];
  if (opts.supportsJoinKeys) {
    children.push({ path: 'unir-llaves', component: AdminJoinKeysComponent });
  }
  if (opts.supportsReset) {
    children.push({ path: 'contrasena', component: TokenVirtualAdminComponent });
  } else {
    children.push({ path: 'contrasena', redirectTo: 'descargar' });
  }
  return children;
};

const gestionChildren: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'estado-tramite' },
  { path: 'estado-tramite', component: GestionEstadoTramiteComponent },
  { path: 'factura', component: GestionFacturaComponent },
  { path: 'revocar', component: GestionRevocarComponent }
];

const routes: Routes = [
  { path: 'auth-callback', component: CcswAuthCallbackComponent },
  {
    path: '',
    component: AppShellComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'firmar' },
      { path: 'firmar', component: MainWorkspaceComponent, data: { animation: 'firmar' } },
      { path: 'verificar', component: MainWorkspaceComponent, data: { animation: 'verificar' } },
      {
        path: 'administrar/certifirma-virtual',
        component: AdminHubComponent,
        data: {
          animation: 'admin-certifirma-virtual',
          adminKind: 'token-virtual',
          resetProfile: 'token-virtual',
          supportsReset: true
        },
        children: adminChildren({ supportsReset: true })
      },
      {
        path: 'administrar/certifirma-virtual-otp',
        component: AdminHubComponent,
        data: {
          animation: 'admin-certifirma-virtual-otp',
          adminKind: 'token-virtual-codigo',
          resetProfile: 'ccsw5',
          supportsReset: true
        },
        children: adminChildren({ supportsReset: true })
      },
      {
        path: 'administrar/certifirma-pkcs10',
        component: AdminHubComponent,
        data: {
          animation: 'admin-certifirma-pkcs10',
          adminKind: 'p10',
          supportsReset: false,
          supportsJoinKeys: true
        },
        children: adminChildren({ supportsReset: false, supportsJoinKeys: true })
      },
      {
        path: 'gestionar',
        component: GestionHubComponent,
        data: { animation: 'gestionar' },
        children: gestionChildren
      },
      {
        path: 'administrar/certifirma-fisico',
        component: TokenFisicoAdminComponent,
        data: { animation: 'admin-certifirma-fisico' }
      },
      {
        path: 'administrar/descargar-certificado',
        component: DescargarCertificadoComponent,
        data: { animation: 'admin-descargar-certificado' }
      },
      { path: 'descargar-certificado', redirectTo: 'administrar/descargar-certificado', pathMatch: 'full' },
      // Compatibilidad con rutas anteriores (Token / P10)
      { path: 'administrar/token-virtual/contrasena', redirectTo: 'administrar/certifirma-virtual/contrasena', pathMatch: 'full' },
      { path: 'administrar/token-virtual/descargar', redirectTo: 'administrar/certifirma-virtual/descargar', pathMatch: 'full' },
      { path: 'administrar/token-virtual', redirectTo: 'administrar/certifirma-virtual', pathMatch: 'full' },
      { path: 'administrar/token-virtual-codigo/contrasena', redirectTo: 'administrar/certifirma-virtual-otp/contrasena', pathMatch: 'full' },
      { path: 'administrar/token-virtual-codigo/descargar', redirectTo: 'administrar/certifirma-virtual-otp/descargar', pathMatch: 'full' },
      { path: 'administrar/token-virtual-codigo', redirectTo: 'administrar/certifirma-virtual-otp', pathMatch: 'full' },
      { path: 'administrar/p10/unir-llaves', redirectTo: 'administrar/certifirma-pkcs10/unir-llaves', pathMatch: 'full' },
      { path: 'administrar/p10/descargar', redirectTo: 'administrar/certifirma-pkcs10/descargar', pathMatch: 'full' },
      { path: 'administrar/p10', redirectTo: 'administrar/certifirma-pkcs10', pathMatch: 'full' },
      { path: 'administrar/token-fisico', redirectTo: 'administrar/certifirma-fisico', pathMatch: 'full' },
      { path: 'administrar-token-virtual', redirectTo: 'administrar/certifirma-virtual/contrasena', pathMatch: 'full' },
      { path: 'administrar-token-virtual-rse', redirectTo: 'administrar/certifirma-virtual-otp/contrasena', pathMatch: 'full' },
      { path: 'administrar-token', redirectTo: 'administrar/certifirma-fisico', pathMatch: 'full' },
      { path: 'almacen-certificados', redirectTo: 'firmar', pathMatch: 'full' }
    ]
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
